document.addEventListener('DOMContentLoaded', function() {
    const video = document.getElementById('main-video');
    
    // Only check if video element exists
    if (!video) { 
        return; 
    }

    const currentUrlParams = new URLSearchParams(window.location.search);

    function getActiveLanguage() {
        const langParam = currentUrlParams.get('lang');
        if (langParam) {
            return langParam.toLowerCase();
        }

        const match = /(?:^|;\s*)diversability_lang=([^;]+)/.exec(document.cookie);
        if (match?.[1]) {
            return decodeURIComponent(match[1]).toLowerCase();
        }

        if (window.dvTranslation?.currentLang) {
            return String(window.dvTranslation.currentLang).toLowerCase();
        }
        return 'en';
    }

    function isTrackMatchingLanguage(trackLang, targetLang) {
        return trackLang === targetLang || (targetLang === 'zh' && (trackLang === 'zh' || trackLang === 'zh-cn'));
    }

    function findBestTrack(targetLang) {
        let matchedTrack = null;
        let defaultTrack = null;

        for (const track of video.textTracks) {
            const trackLang = (track.language || '').toLowerCase();
            if (isTrackMatchingLanguage(trackLang, targetLang)) {
                matchedTrack = track;
            }
            if (trackLang === 'en') {
                defaultTrack = track;
            }
        }

        return matchedTrack || defaultTrack || video.textTracks[0];
    }

    function activateSubtitleTrack(lang) {
        if (!video.textTracks?.length) {
            return;
        }

        const targetLang = (lang || getActiveLanguage() || 'en').toLowerCase();
        const activeTrack = findBestTrack(targetLang);

        if (activeTrack) {
            for (const track of video.textTracks) {
                if (track === activeTrack) {
                    track.mode = 'showing';
                } else {
                    track.mode = 'disabled';
                }
            }
        }
    }

    // Ensure tracks are activated once metadata / tracks are loaded
    if (video.textTracks?.length > 0) {
        activateSubtitleTrack();
    }
    video.addEventListener('loadedmetadata', function() {
        activateSubtitleTrack();
    });

    // Listen for custom language changes if language switcher dispatches events
    window.addEventListener('diversability-language-changed', function(e) {
        if (e?.detail?.lang) {
            activateSubtitleTrack(e.detail.lang);
        }
    });

    // Only autoplay if coming from "Play Video" button click
    if (currentUrlParams.get('autoplay') === '1') {
        const playPromise = video.play();
        
        if (playPromise !== undefined) {
            playPromise.then(() => {
                activateSubtitleTrack();
            }).catch(() => {});
        }
    }
});